import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const updateNotificationsRead = createAsyncThunk('updateNotificationsRead', async (notifId, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.patch(`${process.env.REACT_APP_BACKEND_URL}/api/notifications/${notifId}/update`);
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const updateNotificationSlice = createSlice({
    name: 'update notifications',
    initialState: {
        loading: false,
        message: null,
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(updateNotificationsRead.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(updateNotificationsRead.fulfilled, (state, action) => {
            state.loading = false;
            state.message = action.payload.message
        })
        builder.addCase(updateNotificationsRead.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.response.data.message
        })
    }
})

export default updateNotificationSlice.reducer